import { useMemo } from 'react';
import { chartBlue, chartRed, chartYellow } from '../shared/config';

const useChart = (series = [], config = {}, onAllClick) => {
  return useMemo(() => {
    // Default configuration values
    const defaultConfig = {
      xAxis: {},
      yAxis: {},
      rangeSelector: {
        buttons: [
          { type: 'day', count: 1, text: '1d' },
          { type: 'week', count: 1, text: '1w' },
          { type: 'month', count: 1, text: '1m' },
          { type: 'all', text: '6m' },
        ],
        inputEnabled: true,
        selected: 1,
        inputBoxWidth: 75,
        inputBoxHeight: 18,
        buttonTheme: {
          height: 18,
          padding: 2,
          width: 15,
        },
      },
      title: 'Voltage Profile',
      tooltip: {
        pointFormat:
          '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
        valueDecimals: 2,
        split: true,
      },
      credits: { enabled: false },
      seriesColorMap: {
        R: chartRed,
        Y: chartYellow,
        B: chartBlue,
      },
      chartHeight: 400,
      navigatorEnabled: false,
    };

    // Merging default config with provided config
    const mergedConfig = {
      ...defaultConfig,
      ...config,
      rangeSelector: {
        ...defaultConfig.rangeSelector,
        ...config.rangeSelector,
      },
      xAxis: { ...defaultConfig.xAxis, ...config.xAxis },
      yAxis: { ...defaultConfig.yAxis, ...config.yAxis },
      tooltip: { ...defaultConfig.tooltip, ...config.tooltip },
      credits: { ...defaultConfig.credits, ...config.credits },
    };

    return {
      chart: {
        height: mergedConfig.chartHeight,
        type: 'line',
      },
      rangeSelector: {
        ...mergedConfig.rangeSelector,
        buttons: mergedConfig.rangeSelector.buttons.map((button) => ({
          ...button,
          events:
            button.type === 'all'
              ? {
                  click() {
                    if (onAllClick) onAllClick();
                  },
                }
              : button.events,
        })),
        selected: mergedConfig.rangeSelector.selected,
      },
      title: {
        text: mergedConfig.title,
      },
      xAxis: mergedConfig.xAxis,
      yAxis: mergedConfig.yAxis,
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
              'separator',
              'downloadCSV',
              'downloadXLS',
              'viewData',
            ],
          },
        },
      },
      navigator: {
        enabled: mergedConfig.navigatorEnabled,
      },
      tooltip: mergedConfig.tooltip,
      credits: mergedConfig.credits,
      series: series.map((serie) => ({
        color: chartRed,
        marker: { enabled: false, symbol: 'circle', radius: 2 },
        lineWidth: 2,
        zoneAxis: 'x',
        zones: serie.zones || [],
        ...serie,
      })),
    };
  }, [series, config, onAllClick]);
};

export default useChart;
